const descriptions = {
  section_1_title: {
    id: 'course-authoring.textbooks.sidebar.section-1.title',
    defaultMessage: '¿Por qué debería dividir mi libro de texto en capítulos?',
    description: 'Title for section 1 in the textbooks sidebar',
  },
  section_1_descriptions: {
    id: 'course-authoring.textbooks.sidebar.section-1.descriptions',
    defaultMessage: 'Dividir el libro de texto en varios capítulos reduce los tiempos de carga para los estudiantes, especialmente para aquellos con conexiones a internet lentas. Además, esta división facilita la búsqueda de información sobre temas específicos.',
    description: 'Description for section 1 in the textbooks sidebar',
  },
  section_2_title: {
    id: 'course-authoring.textbooks.sidebar.section-2.title',
    defaultMessage: '¿Qué ocurre si mi libro no está dividido en capítulos?',
    description: 'Title for section 2 in the textbooks sidebar',
  },
  section_2_descriptions: {
    id: 'course-authoring.textbooks.sidebar.section-2.descriptions',
    defaultMessage: 'Si su libro de texto no tiene capítulos individuales, puede subir el texto completo como un solo capítulo e introducir el nombre que desee en el campo Nombre del capítulo.',
    description: 'Description for section 2 in the textbooks sidebar',
  },
  sectionLink: {
    id: 'course-authoring.textbooks.sidebar.section-link',
    defaultMessage: 'Más información',
    description: 'Text for the link to learn more in the textbooks sidebar',
  },
};

export default descriptions;
